import React from 'react';
import { Handle, Position } from 'reactflow';

const UserStoryNode = ({ data }) => {
  return (
    <div className="group relative bg-white border-2 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-200 border-gray-300 w-[300px]">
      <Handle type="target" position={Position.Top} />
      {(data.want && data.benefit && (
        <>
          <div className="bg-gray-900 text-white px-4 py-2 rounded-t-md font-semibold text-center">
            User Story
          </div>
          <div className="p-4 space-y-3">
            <div className="p-2 bg-gray-50 border rounded-md text-center">
              <span className="font-semibold text-gray-900">As a </span>
              {data.role}
            </div>
            <div className="p-2 bg-gray-50 border rounded-md text-center">
              <span className="font-semibold text-gray-900">I want to </span>
              {data.want}
            </div>
            <div className="p-2 bg-gray-50 border rounded-md text-center">
              <span className="font-semibold text-gray-900">So that </span>
              {data.benefit}
            </div>
          </div>
        </>
      )) || (
        <>
          <div className="bg-gray-900 text-white px-4 py-2 rounded-t-md font-semibold text-center">
            Role
          </div>
          <div className="p-2 bg-gray-50 border rounded-md text-center">
            {data.role}
          </div>
        </>
      )}
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default UserStoryNode; 